import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error cannot find declaration file

import CreateCampaignButton from 'AdsUI/components/CreateCampaignButton'; // @ts-expect-error cannot find declaration file

import CreateAudienceButton from 'AdsUI/components/audiences/CreateAudienceButton'; // @ts-expect-error cannot find declaration file

import CreateEventButton from 'AdsUI/components/events/CreateEventButton';
import CreateGoalButton from 'AdsUI/components/goals/CreateGoalButton';

const CreateMenuButton = props => /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
  "data-test-id": "create-menu-button",
  responsive: false
}));

const HeaderCreateButtons = ({
  hasEvents,
  hasGoalsInAdsScope,
  onOpenAudiencePanel,
  showAudienceTour,
  closeAudienceShepherd
}) => {
  if (hasGoalsInAdsScope) {
    return /*#__PURE__*/_jsx(UIDropdown, {
      buttonSize: "small",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "create"
      }),
      buttonUse: "primary",
      Button: CreateMenuButton,
      minMenuWidth: 100,
      placement: "bottom left",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(CreateCampaignButton, {
          isInDropdown: true
        }), /*#__PURE__*/_jsx(CreateAudienceButton, {
          onOpenAudiencePanel: onOpenAudiencePanel,
          isInDropdown: true,
          enableTour: showAudienceTour,
          closeAudienceShepherd: closeAudienceShepherd
        }), hasEvents && /*#__PURE__*/_jsx(CreateEventButton, {
          isInDropdown: true
        }), /*#__PURE__*/_jsx(CreateGoalButton, {})]
      })
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasEvents && /*#__PURE__*/_jsx(CreateEventButton, {}), /*#__PURE__*/_jsx(CreateAudienceButton, {
      onOpenAudiencePanel: onOpenAudiencePanel,
      enableTour: showAudienceTour,
      closeAudienceShepherd: closeAudienceShepherd
    }), /*#__PURE__*/_jsx(CreateCampaignButton, {})]
  });
};

export default HeaderCreateButtons;